import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Modal, Row, Table} from "reactstrap";
import CardHeader from "reactstrap/es/CardHeader";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import resourceHelper from "../../helpers/ResourceHelper";
import {student_strings} from "../../translations/student_translations";
import StudentSearch from "../Search/StudentSearch";
import ResourceApiService from "../../api/resource-api-service";
import RulesOverview from "./RulesOverview";
import CheckBoxList from "../Tables/CheckBoxList";
import TicketTypeApiService from "../../api/tt-api-service";
import businessHelper from "../../helpers/BusinessHelper";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);

const propTypes = {};

let colors = ["6F5374", "27578A", "7799CC", "8B2107", "E07D54", "3A80BF", "713654", "75B65D", "5E3A65", "418026", "e1ad21", "a109b1", "b5651d", "09a374", "755F82"]

class EditClassTypeView extends React.Component {
    handleChange = this.handleChange.bind(this);
    showStudentsModal = this.showStudentsModal.bind(this);
    handleColorSelection = this.handleColorSelection.bind(this);
    closeStudentSearchView = this.closeStudentSearchView.bind(this);
    addStudentToClassType = this.addStudentToClassType.bind(this);
    removeStudentFromClassType = this.removeStudentFromClassType.bind(this);
    postClassType = this.postClassType.bind(this);
    showRulesModal = this.showRulesModal.bind(this);
    updateClassType = this.updateClassType.bind(this);
    updateClassTypeInState = this.updateClassTypeInState.bind(this);
    renderRulesModal = this.renderRulesModal.bind(this);
    renderTTModal = this.renderTTModal.bind(this);
    getTicketTypes = this.getTicketTypes.bind(this);
    showTTModal = this.showTTModal.bind(this);
    handleTicketTypeCbChange = this.handleTicketTypeCbChange.bind(this);
    handleTTSelected = this.handleTTSelected.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            classType: props.classType || resourceHelper.emptyClassType(),
            rules: null,
            inputsUpdated: true,
            showRuleModal: false,
            teachers: null,
            rooms: null,
            showTTModal: false,
            ticketTypes: null,
            selectedTicketTypes: null,
            validation: {
                name: true,
            }
        };
    }

    handleTicketTypeCbChange(event) {

        let checked = event.target.checked;
        if (checked) {
            this.setState({selectedTicketTypes: []})
        } else {
            this.showTTModal()
        }
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        name: newValue
                    }
                }));
                break;
            case "input-duration":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        duration: newValue
                    }
                }));
                break;
            case "input-description":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        description: newValue
                    }
                }));
                break;
            case "input-free-cb":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        is_free: checkBoxValue
                    }
                }));
                break;
            case "input-workshop-cb":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        is_workshop: checkBoxValue
                    }
                }));
                break;
            case "input-public-cb":
                this.setState(prevState => ({
                    classType: {
                        ...prevState.classType,
                        public: checkBoxValue
                    }
                }));
                break;

            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.classType !== this.props.classType) {
            this.setState({
                classType: nextProps.classType,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.classType !== this.state.classType) {
            this.handleValidation();
        }
    }

    // updateClassType(e) {
    //     e.preventDefault();
    // }

    render() {
        this.localize();

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showStudentsModal &&
                    this.renderStudentSearchModal()
                    }
                    {this.state.showRuleModal &&
                    this.renderRulesModal()
                    }
                    {this.state.showTTModal &&
                    this.renderTTModal()
                    }
                    {this.state.showGroupModal &&
                    this.renderGroupModal()
                    }
                    <Card className="bg-secondary shadow">
                        <CardHeader className="bg-white border-0">
                            <Row className="align-items-center">
                                <Col xs="10">
                                    <h3 className="mb-0">{this.state.classType.id ? resourceStrings.edit_class_type : resourceStrings.new_class_type}</h3>
                                </Col>
                                <Col xs="2">
                                    <div className="modal-header float-right">
                                        <button
                                            aria-label="Close"
                                            className="close"
                                            data-dismiss="modal"
                                            type="button"
                                            onClick={e => this.props.closeEditClassTypeView(e)}
                                        >
                                            <span aria-hidden={true}>×</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Form onSubmit={this.handleSubmit}>
                                {this.state.classType &&
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col lg="12">
                                            <FormGroup style={{verticalAlign: 'center='}}>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-name"
                                                >
                                                    {resourceStrings.title}
                                                </label>
                                                <Input
                                                    placeholder={resourceStrings.title}
                                                    className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.classType.name}
                                                    id="input-name"
                                                    type="name"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12">
                                            <FormGroup style={{verticalAlign: 'center='}}>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-duration"
                                                >
                                                    {resourceStrings.class_lasts}
                                                </label>
                                                <Input
                                                    placeholder={resourceStrings.duration}
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.classType.duration}
                                                    id="input-duration"
                                                    type="number"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-description"
                                                >
                                                    {resourceStrings.description}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-description"
                                                    placeholder={resourceStrings.ct_description_placeholder}
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.classType.description}
                                                    rows="2"
                                                    type="textarea"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr/>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-free-cb"
                                                    onChange={this.handleChange}
                                                    checked={this.state.classType.is_free === true}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-free-cb">
                                                    {resourceStrings.free_class}
                                                </label>
                                                <div>
                                                    <i><small>{resourceStrings.free_class_expl}</small></i>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-public-cb"
                                                    onChange={this.handleChange}
                                                    checked={this.state.classType.public === true}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-public-cb">
                                                    {resourceStrings.public}
                                                </label>
                                                <div>
                                                    <i><small>{resourceStrings.public_class_expl}</small></i>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-workshop-cb"
                                                    onChange={this.handleChange}
                                                    checked={this.state.classType.is_workshop === true}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-workshop-cb">
                                                    {resourceStrings.workshop}
                                                </label>
                                                <div>
                                                    <small>{resourceStrings.workshop_expl}</small>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <hr/>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-tt-cb"
                                                    onChange={this.handleTicketTypeCbChange}
                                                    checked={this.state.selectedTicketTypes && this.state.selectedTicketTypes.length > 0 ? false :
                                                        this.state.selectedTicketTypes && this.state.selectedTicketTypes.length === 0 ? true : (this.state.classType.ticket_types && this.state.classType.ticket_types.length === 0)}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-tt-cb">
                                                    {resourceStrings.all_ticket_types}
                                                </label>
                                                <div>
                                                    <i> <small>{resourceStrings.all_ticket_types_expl}</small></i>
                                                </div>
                                            </div>

                                            {this.state.classType.ticket_types && this.state.classType.ticket_types.length > 0 &&
                                            <div>
                                                <Button
                                                    color="secondary"
                                                    size="lg"
                                                    onClick={e => this.showTTModal(e)}
                                                >
                                                    ({this.state.selectedTicketTypes ? this.state.selectedTicketTypes.length : (this.state.classType.ticket_types ? this.state.classType.ticket_types.length : "0")}) {resourceStrings.manage_tt}
                                                </Button>
                                            </div>
                                            }
                                        </Col>
                                    </Row>

                                    <hr/>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-description"
                                                >
                                                    {commonStrings.group_only}
                                                </label>
                                                <div>
                                                    <Button
                                                        color="secondary"
                                                        size="lg"
                                                        disabled={this.saveButtonDisabled()}
                                                        onClick={e => this.showGroupModal(e)}
                                                    >
                                                        ({this.state.classType.student_ranks ? this.state.classType.student_ranks.length : "0"}) {commonStrings.select_groups}
                                                    </Button>
                                                </div>

                                                {this.state.classType.name.length === 0 &&
                                                <div style={{color: "red"}}>
                                                    <i> <small>{resourceStrings.ct_add_name_before}</small></i>
                                                </div>
                                                }
                                                <div>
                                                    <i> <small>{commonStrings.group_only_expl}</small></i>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr/>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-description"
                                                >
                                                    {resourceStrings.regular_class}
                                                </label>
                                                <div>
                                                    <Button
                                                        color="secondary"
                                                        size="lg"
                                                        disabled={this.saveButtonDisabled()}
                                                        onClick={e => this.showRulesModal(e)}
                                                    >
                                                        ({this.state.classType.rules ? this.state.classType.rules.length : "0"}) {resourceStrings.manage_rules}
                                                    </Button>
                                                </div>

                                                {this.state.classType.name.length === 0 &&
                                                <div style={{color: "red"}}>
                                                    <i> <small>{resourceStrings.ct_add_name_before}</small></i>
                                                </div>
                                                }
                                                <div>
                                                    <i> <small>{resourceStrings.regular_class_expl}</small></i>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr/>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-description"
                                                >
                                                    {resourceStrings.regular_clients}
                                                </label>
                                                <div>
                                                    <Button
                                                        color="secondary"
                                                        size="lg"
                                                        disabled={this.state.classType.name.length === 0}
                                                        onClick={e => this.showStudentsModal(e)}
                                                    >
                                                        ({this.state.classType.students ? this.state.classType.students.length : "0"}) {resourceStrings.manage_regular_clients}
                                                    </Button>
                                                </div>
                                                {this.state.classType.name.length === 0 &&
                                                <div style={{color: "red"}}>
                                                    <i> <small>{resourceStrings.ct_add_name_before}</small></i>
                                                </div>
                                                }
                                                <div>
                                                    <i> <small>{resourceStrings.regular_clients_expl}</small></i>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr/>
                                    <Row style={{width: "100%"}}>
                                        <Col lg="12">
                                            <label
                                                className="form-control-label"
                                            >
                                                {resourceStrings.class_color}
                                            </label>
                                            <Row
                                                style={{width: "100%", display: "flex", flexWrap: "wrap", margin: 0}}>
                                                {colors.map((color, index) => {
                                                    return (
                                                        <Button
                                                            style={{
                                                                backgroundColor: `#${color}`,
                                                                width: "4rem",
                                                                minWidth: "4rem",
                                                                minHeight: "4rem",
                                                                height: "4rem",
                                                                margin: 10,
                                                                color: "white"
                                                            }}
                                                            outline="button"
                                                            size="lg"
                                                            id={color}
                                                            onClick={e => this.handleColorSelection(e, color)}
                                                        >
                                                            {this.state.classType.clr == color ? "✔" : ""}
                                                        </Button>
                                                    )
                                                })}
                                            </Row>
                                        </Col>
                                    </Row>

                                </div>
                                }

                                <Row className="mt-4">
                                    <Col lg="12">
                                        <Col className="text-right">
                                            <Button
                                                color="warning"
                                                href="#pablo"
                                                outline="button"
                                                size="lg"
                                                onClick={e => this.props.closeEditClassTypeView(e)}
                                            >
                                                {commonStrings.close}
                                            </Button>

                                            <Button
                                                color={this.validationCleared() ? "default" : "secondary"}
                                                disabled={this.saveButtonDisabled()}
                                                href="#pablo"
                                                size="lg"
                                                onClick={e => this.updateClassType(e)}
                                            >
                                                {commonStrings.save}
                                            </Button>
                                        </Col>
                                    </Col>
                                </Row>

                            </Form>
                        </CardBody>
                    </Card>
                </>
            </LoadingOverlay>
        )
    }

    handleValidation() {
        this.validateName();
    }

    validateName() {
        const name = this.state.classType.name;

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: name.length >= 2
            }
        }));
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    toggleStudentsModal = state => {
        this.setState({
            showStudentsModal: !this.state.showStudentsModal
        });
    };

    toggleRulesModal = state => {
        this.setState({
            showRuleModal: !this.state.showRuleModal
        });
    };

    showStudentsModal(e) {
        e.preventDefault();

        if (this.state.classType.id) {
            this.setState({
                showStudentsModal: true
            });
        } else this.prePostClassType("s")

    }

    showRulesModal(e) {
        if (e) {
            e.preventDefault()
        }

        if (this.state.teachers === null || this.state.rooms === null) {
            this.getTeachersAndRooms()
        } else {
            if (this.state.classType.id) {
                this.setState({
                    showRuleModal: true
                });
            } else this.prePostClassType("r")
        }

    }

    getTeachersAndRooms() {
        this.setState({isLoading: true});

        ResourceApiService.teachersAndRooms()
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res[0] || [],
                    rooms: res[1] || [],
                });

                this.showRulesModal()
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    renderRulesModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRuleModal}
                toggle={() => this.toggleRulesModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4>{resourceStrings.manage_rules}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleRulesModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">

                        <CardBody className="px-lg-5 py-lg-5">
                            <RulesOverview
                                rules={this.state.classType.rules || []}
                                classTypeId={this.state.classType.id}
                                updateClassType={this.updateClassTypeInState}
                                teachers={this.state.teachers}
                                rooms={this.state.rooms}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderStudentSearchModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showStudentsModal}
                toggle={() => this.toggleStudentsModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4>{studentStrings.add_regular_client}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleStudentsModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardBody className="px-lg-5 py-lg-5">
                            <StudentSearch
                                closeStudentSearchView={this.closeStudentSearchView}
                                addStudent={this.addStudentToClassType}
                                removeStudentFromClassType={this.removeStudentFromClassType}
                                students={this.state.classType && this.state.classType.students ? this.state.classType.students : []}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    closeStudentSearchView(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showStudentsModal: false
        });
    }

    handleColorSelection(e, color) {
        e.preventDefault();

        this.setState(prevState => ({
            classType: {
                ...prevState.classType,
                clr: color
            }
        }));
    }

    addStudentToClassType(client) {
        this.setState({isLoading: true});

        ResourceApiService.addClientToClassType(this.state.classType.id, client.id)
            .then(res => {
                this.setState({
                    classType: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });

    }

    removeStudentFromClassType(e, client) {
        e.preventDefault();

        ResourceApiService.removeClientFromClassType(this.state.classType.id, client.id)
            .then(res => {
                this.setState({
                    classType: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });

    }

    postClassType() {
        this.setState({isLoading: true});

        ResourceApiService.postClassType(this.state.classType)
            .then(res => {
                this.setState({
                    classType: res,
                    isLoading: false
                });

                this.props.closeEditClassTypeView(null, res)
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    updateClassType() {
        this.setState({isLoading: true});

        const ct = this.state.classType;
        if (this.state.selectedTicketTypes !== null) {
            if (this.state.selectedTicketTypes.length > 0) {
                const tts = this.state.selectedTicketTypes.map(it => it.id).join(",");
                ct.tt_ids = tts;
            } else {
                ct.tt_ids = -1;
            }
        }

        if (this.state.classType.id) {

            ResourceApiService.updateClassType(ct)
                .then(res => {
                    this.setState({
                        classType: res,
                        isLoading: false
                    });

                    this.props.closeEditClassTypeView(null, res)
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        } else {
            ResourceApiService.postClassType(ct)
                .then(res => {
                    this.setState({
                        classType: res,
                        isLoading: false
                    });

                    this.props.closeEditClassTypeView(null, res)
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        }
    }

    prePostClassType(target) {
        this.setState({isLoading: true});

        ResourceApiService.postClassType(this.state.classType)
            .then(res => {
                this.setState({
                    classType: res,
                    isLoading: false
                });

                // target is the reason we prepost class type. it means we do it to either add "s"tudents or "r"ules
                if (target === "s") {
                    this.setState({showStudentsModal: true})
                } else if (target === "r") {
                    this.setState({showRuleModal: true})
                } else if (target === "g") {
                    this.setState({showGroupModal: true})
                }
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    updateClassTypeInState(ct) {
        this.setState(prevState => ({
            classType: {
                ...prevState.classType,
                rules: ct.rules
            }
        }));
    }

    showTTModal(e) {
        if (this.state.selectedTicketTypes === null) {
            this.setState({selectedTicketTypes: this.state.classType.ticket_types});
        }

        if (e) e.preventDefault();

        if (this.state.ticketTypes === null) this.getTicketTypes();
        else {
            this.setState({showTTModal: true})
        }
    }

    toggleTTModal = state => {
        this.setState({
            showTTModal: !this.state.showTTModal
        });
    };

    renderTTModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showTTModal}
                toggle={() => this.toggleTTModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4>{resourceStrings.select_tts}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleTTModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        {(!this.state.ticketTypes || this.state.ticketTypes.length === 0) &&
                        <div className="text-muted text-center mt-2 mb-3">
                            <small style={{color: "red"}}>{resourceStrings.no_tt}</small>
                        </div>
                        }
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {this.renderTTTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    showGroupModal() {
        if (this.state.classType.id) {
            this.setState({
                showGroupModal: true
            });
        } else this.prePostClassType("g")
    }

    toggleGroupModal = state => {
        this.setState({
            showGroupModal: !this.state.showGroupModal
        });
    };

    renderGroupModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showGroupModal}
                toggle={() => this.toggleGroupModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4>{commonStrings.select_groups}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleGroupModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        <div className="text-muted text-center mt-2 mb-3">
                            <small>{commonStrings.group_only_expl}</small>
                        </div>

                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {this.renderGroupTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    getTicketTypes() {
        this.setState({isLoading: true});

        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false
                });

                this.showTTModal()

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    };

    renderTTTable() {
        const selected = (this.state.selectedTicketTypes) ? this.state.selectedTicketTypes.map(it => it.id) : this.state.classType.ticket_types.map(it => it.id) || []
        return (this.state.ticketTypes).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleTTSelected}/>
            )
        })
    };

    renderGroupTable() {
        const selected = (this.state.classType && this.state.classType.student_ranks) ? this.state.classType.student_ranks.map(it => it.id) : []
        return (businessHelper.business().student_ranks || []).map((group, index) => {

            return (
                <CheckBoxList item={{id: group.id, label: group.title}} key={group.id}
                              selected={selected.includes(group.id)}
                              handleChange={this.handleGroupSelected.bind(this)}/>
            )
        })
    };

    handleGroupSelected(checked, id) {
        this.setState({isLoading: true})

        if (checked) {
            ResourceApiService.addGroupToClassType(this.state.classType.id, id)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        classType: res
                    });
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        } else {
            ResourceApiService.removeGroupFromClassType(this.state.classType.id, id)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        classType: res
                    });
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        }
    }

    handleTTSelected(checked, id) {
        const tt = this.state.ticketTypes.find(it => it.id === id);
        const selected = ((this.state.selectedTicketTypes) ? this.state.selectedTicketTypes : []);
        const selectedIds = ((this.state.selectedTicketTypes) ? this.state.selectedTicketTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);

                    this.setState({selectedTicketTypes: selected});
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);

                    this.setState({selectedTicketTypes: selected});

                }
            }
        }
    }

    saveButtonDisabled() {
        return this.state.classType.name.length === 0
    }
}

EditClassTypeView.propTypes = propTypes;

export default EditClassTypeView;